import { render, staticRenderFns } from "./CardSelection.vue?vue&type=template&id=3b4fce4a&scoped=true"
import script from "./CardSelection.vue?vue&type=script&lang=js"
export * from "./CardSelection.vue?vue&type=script&lang=js"
import style0 from "./CardSelection.vue?vue&type=style&index=0&id=3b4fce4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4fce4a",
  null
  
)

export default component.exports